import { render, staticRenderFns } from "./ShiftTable.vue?vue&type=template&id=4f4222ec&scoped=true"
import script from "./ShiftTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./ShiftTable.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ShiftTable.vue?vue&type=style&index=0&id=4f4222ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f4222ec",
  null
  
)

export default component.exports